

  import { gql } from "@apollo/client";
  
  export const CREATE_OR_UPDATE_CONTACTS_TEAM_MEMBERS = gql`
  mutation CreateOrUpdateContact($input: ContactInput) {
    createOrUpdateContact(input: $input) {
      contact {
        arcimedes_row_id
              first_name
              last_name
              title
              phone
              linkedin
              email
              description
              photo
              credentials
              is_agent
              deleted
              is_admin
              visible_on_website
              starting_date
              termination_date
              yrs_at_strive
              birth_date
              age
              on_phones
              in_pool
              first_listing
              first_closing
              address
              city
              state
              zip
              cell_phone
              territory
              w4_form
              w9_form
              payroll_form
              ca_form
              it_policy_form
              trade_secrets_form
              arcimedes_created
              arcimedes_created_by
              arcimedes_modified
              arcimedes_modified_by
              contact_id
              name
              notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      }
      message
      success
      error
    }
  }
  `

  export const CREATE_OR_UPDATE_CONTACTS_TENANTS = gql`
  mutation CreateOrUpdateContact($input: ContactInput) {
    createOrUpdateContact(input: $input) {
      contact {
           arcimedes_row_id
              name
              deleted
              contact_id
              address
              zip
              city
              state
              first_name
              last_name
               notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
              email
              cell_phone
      }
      message
      success
      error
    }
  }
  `

  export const CREATE_OR_UPDATE_CONTACTS_BUYERS = gql`
mutation CreateOrUpdateContact($input: ContactInput) {
  createOrUpdateContact(input: $input) {
    contact {
         arcimedes_row_id
            status
            agent
            agent_firm
            first_name
            last_name
            company_name
            company_address
            company_city
            company_state
            company_zip
            phone
            email
             notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
            profile
            category
            type
            single_tenant_subcategory
            multi_tenant_subcategory
            market
            price_min
            price_max
            cap_rate_min
            cap_rate_max
            strive_agent
            strive_agent_last_name
            cell_phone
            deleted
            arcimedes_created
            arcimedes_created_by
            arcimedes_modified
            arcimedes_modified_by
            contact_id
            name
    }
    message
    success
    error
  }
}
  `
  export const CREATE_OR_UPDATE_CONTACTS_VENDORS = gql`
  mutation CreateOrUpdateContact($input: ContactInput) {
    createOrUpdateContact(input: $input) {
      contact {
           arcimedes_row_id
              status
              agent
              agent_firm
              first_name
              last_name
              company_name
              company_address
              company_city
              company_state
              company_zip
              phone
              email
               notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
              cell_phone
              deleted
              contact_id
              name
              vendor_type
              website
      }
      message
      success
      error
    }
  }
    `
  export const CREATE_OR_UPDATE_CONTACTS_INVESTORS = gql`
  mutation CreateOrUpdateContact($input: ContactInput) {
    createOrUpdateContact(input: $input) {
      contact {
           arcimedes_row_id
              status
              agent
              agent_firm
              first_name
              last_name
              company_name
              company_address
              company_city
              company_state
              company_zip
              phone
              email
               notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
              profile
              category
              type
              single_tenant_subcategory
              multi_tenant_subcategory
              market
              price_min
              price_max
              cap_rate_min
              cap_rate_max
              strive_agent
              strive_agent_last_name
              cell_phone
              deleted
              arcimedes_created
              arcimedes_created_by
              arcimedes_modified
              arcimedes_modified_by
              contact_id
              name
              last_modified
              hsc_id
              contact_type
              website
              date_of_down_leg
      }
      message
      success
      error
    }
  }
    `
  export const CREATE_OR_UPDATE_CONTACTS_AGENTS = gql`
  mutation CreateOrUpdateContact($input: ContactInput) {
  createOrUpdateContact(input: $input) {
    success
    message
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      name
      address
      city
      state
      zip
       notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      deleted
      hsc_id
      company_address
      company_city
      company_state
      company_zip
      website
    }
    error
  }
}
  `
  export const CREATE_OR_UPDATE_CONTACTS_SELLERS = gql`
  mutation CreateOrUpdateContact($input: ContactInput) {
  createOrUpdateContact(input: $input) {
    success
    message
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      status
      company_name
      company_address
      company_city
      company_state
      company_zip
      first_name
      last_name
      phone
      cell_phone
      email
       notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      profile
      last_modified
      deleted
      firm
      agent
      agent_firm
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
     name
    }
    error
  }
}
  `
  export const CREATE_OR_UPDATE_CONTACTS_LENDERS = gql`
 mutation CreateOrUpdateContact($input: ContactInput) {
  createOrUpdateContact(input: $input) {
    success
    message
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      name
      city
      state
      contact_name
      contact_phone
      contact_email
      email
       notes {
        arcimedes_row_id
        text
        date
        user_name
        user_id
        contact_id
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
      }
      address
      city
      state
      zip
      first_name
      last_name
      cell_phone
      deleted
      hsc_id
      company_name
      company_address
      company_city
      company_state
      company_zip
      website
    }
    error
  }
}
  `


  export const MERGE_DELETE_DUPLICATE_CONTACT = gql`
  mutation MergeAndDeleteDuplicate($input: margeAndDeleteInput) {
  mergeAndDeleteDuplicate(input: $input) {
    success
    message
    error
  }
}
  `